<template>
</template>

<script>
import lozad from 'lozad';
export default {
    data: function () {
        return {
            error: false,
            posts: [],
        }
    },
    props: [
        'queryUrl',
    ],
    mounted() {
        this.queryApi();
    },
    updated: function () {
        const observerDynamic = lozad();
        observerDynamic.observe();
    },
    methods: {

        /**
         * Query the internal API to get the recent posts
         *
         * @return  {void}
         */
        queryApi() {
            axios
                .get(this.queryUrl )
                .then(response => {
                    this.error = false;

                    this.posts = this.posts.concat(response.data.data);
                })
                .catch(error => {
                    this.error = true;
                })
        },
    },
}
</script>
